<template>
  <div class="fcc-history">
    <div class="holder">
      <h3>{{title}}</h3>
      <div class="history-elements">
        <div
          class="history-element-holder"
          v-for="(item, index) in history[activeIndex].items"
          :key="item.image"
          :data-aos-delay="index*200"
          data-aos="zoom-in"
          data-aos-duration="1000"
          data-aos-easing="ease-out-cubic"
        >
          <div class="image">
            <img :src="require(`@/assets/history/${item.image}`)" />
          </div>
          <div class="info">
            <div class="label">{{item.label}}</div>
            <div class="date">{{item.date}}</div>
          </div>
        </div>
      </div>
      <div class="divider" />
      <div class="ui-elements">
        <div
          class="ui-element"
          v-for="(item, index) in history"
          :key="index"
          :data-aos-delay="index*200"
          data-aos="zoom-in"
          data-aos-duration="1000"
          data-aos-easing="ease-out-cubic"
          @click="activeIndex = index"
        >
          <div class="background" :class="(index == activeIndex ? 'active' : '')"></div>
          <div class="label">{{item.label}}</div>
          <div class="mobile-history">
            <div
              class="history-element-holder"
              v-for="(element) in history[index].items"
              :key="element.image"
              data-aos="zoom-in"
              data-aos-duration="1000"
              data-aos-easing="ease-out-cubic"
            >
              <div class="image">
                <img :src="require(`@/assets/history/${element.image}`)" />
              </div>
              <div class="info">
                <div class="label">{{element.label}}</div>
                <div class="date">{{element.date}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FCTitle from "@/components/patterns/FCTitle";
export default {
  components: {
    FCTitle
  },
  props: {
    history: Array,
    title: String
  },
  data() {
    return {
      activeIndex: this.history.length - 1
    };
  }
};
</script>

<style lang="scss" scoped>
.fcc-history {
  background-image: linear-gradient(
    270deg,
    rgba(5, 17, 42, 0.84) 53%,
    rgba(0, 0, 0, 0.84) 100%
  );
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  min-height: 100%;
}
.holder {
  margin-top: 275px;
  padding: 0 100px;
  z-index: 1;
}
h3 {
  font-weight: bold;
  font-size: 42px;
  color: #ff5100;
  letter-spacing: 0;
  text-align: center;
  line-height: 28px;
  text-transform: uppercase;
  margin-bottom: 25px;
}
.mobile-history {
  .history-element-holder {
    display: block;
  }
}
.history-elements {
  height: 225px;
  overflow: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding-bottom: 8px;
  text-align: center;
  text-align: center;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar-track {
    background-color: rgba(#fff, 0.2);
  }
  &::-webkit-scrollbar {
    background-color: #000;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: $primary-color;
  }
}
.divider {
  background-image: linear-gradient(
    91deg,
    rgba(255, 255, 255, 0) 1%,
    #ffffff 36%,
    #ffffff 69%,
    rgba(255, 255, 255, 0) 100%
  );
  height: 2px;
  width: 100%;
  margin-top: 30px;
  content: " ";
  display: block;
}
.history-element-holder {
  display: inline-block;
  vertical-align: top;
  width: 175px;
  height: 225px;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-size: contain;
  white-space: normal;
  color: #fff;
  letter-spacing: 0;
  line-height: 18px;
  text-transform: uppercase;
  position: relative;

  z-index: 1;
  &:not(:last-child) {
    margin-right: 25px;
  }
  .label {
    font-size: 13px;
    line-height: 1.1;
    font-weight: bold;
    margin: 10px 0;
  }
  .info {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba($accent-color, 0.5);
    background-image: linear-gradient(
      180deg,
      rgba(5, 17, 42, 0) 53%,
      rgba($accent-color, 1) 100%
    );
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  .date {
    font-size: 12px;
  }
  .image {
    position: relative;
    overflow: hidden;
    height: 100%;
    width: 100%;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      object-position: top;
    }
  }
}
.ui-elements {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
}
.ui-element {
  font-size: 42px;
  color: #ffffff;
  letter-spacing: 0;
  width: 250px;
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .label {
    position: relative;
  }
  .background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    border: 3px solid #ffffff;
    box-shadow: 0px 0px 15px 0px $accent-color;
    transition: opacity 0.6s;
    &.active {
      opacity: 1;
    }
  }
  .mobile-history {
    display: none;
  }
}
@media (max-width: 1000px) {
  .ui-element {
    display: block;
    text-align: center;
    .background {
      opacity: 1;
    }
    .mobile-history {
      display: block;
    }
    .history-element-holder {
      margin-right: 0;
      width: 100%;
    }
  }
  .history-elements {
    display: none;
  }
  .holder {
    margin-top: 90px;
    padding: 0 20px;
  }
  .ui-elements {
    flex-direction: column-reverse;
  }
  .ui-element {
    height: auto;

    align-items: start;
    padding: 10px;
    .background {
      background-image: url("~@/assets/history-box.svg");
      background-position: center;
      background-size: cover;
    }
  }
}
</style>